<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="项目" left-text="返回" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
        <van-search class="search-box" shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch"
                    @cancel="onSearch" @clear="onSearch">
            <div slot="action" @click="onSearch">搜索</div>
        </van-search>
        <div id="newBtn" v-show="isShowAddBtn"><span style="font-size: 50px;" class="icon iconfont icon-jiahao-o" @click="showPopup()"></span>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
                <div v-for="project in list" class="card" :key="project.uuid"
                     @click="openDetail(project.uuid,project.advisorId,project)">
                    <table class="layout">
                        <tr>
                            <td class="avatar-box" rowspan="4">
                                <img :src="avatarUrl + project.advisorIdavatar" class="avatar" alt="avatar">
                                <p class="advisor">{{project.advisorIdname}}</p>
                            </td>
                            <td colspan="2">
                                <div class="header">
                                    <span class="title">{{project.name || "无"}}</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="content">
                                <p v-for="field in displayField" :key="field.fieldName">
                                    <span :class="icon + field.appIcon"></span>
                                    <span>{{project[field.dictionary ? field.fieldName+'name':field.fieldName] || '无'}}</span>
                                </p>
                            </td>
                        </tr>
                        <!-- <tr>
                            <td>
                                <span style="margin-left:0;"
                                      v-if="project.advisorId === userId&&project.formDataId==='0'"
                                      class="icon iconfont icon-project"
                                      @click="transferToProject(project,$event)"></span>
                                <span style="margin-left:0;"
                                      v-if="project.advisorId === userId&&project.formDataId!=='0'"
                                      class="icon iconfont icon-project"
                                      @click="openToProjectForm(project,$event)"></span>
                            </td>
                        </tr> -->
                    </table>
                </div>
            </van-list>
        </van-pull-refresh>
		<van-popup v-model="showTableGrid" position="right">
			<van-nav-bar title="新建项目" left-text="返回" left-arrow @click-left="cancel"></van-nav-bar>
			 <table-grid v-if="showTableGrid" table-name="crm_project" :data-id="'0'" :grouping="grouping" :default-value="defaultValue" @savecomplate="cancel">
			</table-grid>
		</van-popup>
	</div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup,PullRefresh,NavBar} from 'vant';
    import userInfo from '../store/userInfo';
    import projectService from "../service/projectService";
    import moment from "moment";
    import {formatDictionary} from "../utils/dictionary";
    import {formatMoney} from "../utils/money";
    import fieldDescriptionService from "../service/fieldDescriptionService";
    import {API_URL} from "../common/config";
	import configService from "../service/configService";

    export default {
        data: function () {
            return {
                list: [],
				isShowAddBtn: false,
                searchParam:{},
                loading: false,
                finished: false,
                pageIndex: 0,
                displayField: [],
                value: '',
                workflowTemplateId:'f3f6afbe8fae4ab0bddc483cf9531e28',
                dictionaryName : '',
                refreshing: false,
                type: 0,
                clueId:'',
				grouping: false,
				showTableGrid:false,
				dictionary: {},
				defaultValue: {
					
				}
            }
        },
        store: userInfo,
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
			[NavBar.name]: NavBar,
        },
        computed: {
            userId() {
                return this.$store.getters.getUserId;
            },
            avatarUrl() {
                return API_URL + "/oa/common/attachment/showImage?id=";
            },
            icon() {
                return "iconfont ";
            }
        },
        created: async function () {
            this.searchField = await fieldDescriptionService.getSearchParam("crm_project");
			let resp = await configService.getConfigByName("项目录入模式");
			if (resp.data.Status === "1"){
			    if (resp.data.Data && resp.data.Data.value === "直接新建"){
			        this.isShowAddBtn = true;
			    }
			}
        },
        methods: {
            async onLoad() {
                if (this.displayField.length < 1){
                    let displayField = await fieldDescriptionService.getFieldDisplayOnAPP("crm_project");
                    if (displayField.data.Status === "1") {
                        this.displayField = displayField.data.Data;
                    }
                }
                if (!this.dictionaryName){
                    let displayField = await fieldDescriptionService.getDictionaryName("crm_project");
                    if (displayField.data.Status === "1") {
                        this.dictionaryName = displayField.data.Data;
                    }
                }
                this.pageIndex++;
                let resp = await projectService.getList(this.pageIndex, this.value);
                resp.data.Data.data.forEach(item => {
                    item.createTime = moment(item.createTime).format('YYYY-MM-DD');
                    item.amount = formatMoney(item.amount === undefined ? "" : item.amount);
                    item.advisorId = item.advisorId === undefined ? item.creatorId  : item.advisorId;
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
				this.dictionary = resp.data.Data.dictionary;
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onSearch() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
            onRefresh() {
                this.finished = false;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
            openDetail(id,advisorId,project){
				this.$router.push({path:"projectDetails",query:{uuid:id,advisorId:advisorId,project:JSON.stringify(project),dictionary:JSON.stringify(this.dictionary)}})
                // window.open(API_URL+"/crm/html/saleschance/detail?uuid=" + id +"&advisorId="+advisorId);
            },
            transferToProject(project,e){
                e.stopPropagation();
                window.open( API_URL +'/wf/form/vsheet/form?workflowTemplateId='+this.workflowTemplateId+'&id=0&projectId='+project.uuid+'&code='+project.code+'&advisorId='+project.advisorId+'&region='+project.region+'&regionProvince='+project.province+
                    '&source='+project.source+'&projectName='+project.name);
            },
            openToProjectForm(project,e){
                e.stopPropagation();
                window.open( API_URL +'/wf/form/vsheet/form?workflowTemplateId='+this.workflowTemplateId+'&id='+project.formDataId);
            },
			onClickLeft(){
				window.location.href = '/colseWebView';
			},
			cancel() {
				this.showTableGrid = false;
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			showPopup() {
				if(this.userId) {
					this.defaultValue = {
						createTime: moment(new Date()).format('YYYY-MM-DD HH:mm'),
						creatorId: this.userId,
						advisorId: this.userId,
					}
					this.showTableGrid = true;
				}
			}
        }
    };

</script>
<style>
    #newBtn{
        position:fixed;
        right:20px;
        bottom:30px;
        z-index: 9999;
    }
	.search-box {
		margin-top:120px;
	}
</style>